<template>
  <label :class="['v-select', !!value && 'v-select--filled']">
    <select class="v-select__select" v-model="value">
      <option disabled>{{placeholder}}</option>
      <slot></slot>
    </select>
    <div class="v-select__wrapper">
      <span class="v-select__label">{{placeholder}}</span>
      <span class="v-select__value">{{value}}</span>
      <svg width="12" height="7" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l4.679 4.862a.442.442 0 0 0 .642 0L11 1" stroke="#282828" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      value: this.$attrs.value
    };
  },
  props: {
    placeholder: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-select {
  display: flex;
  position: relative;

  &__wrapper {
    width: 100%;
    height: 50px;
    padding: 0 10px;
    border: 1px solid #b8b8b8;
    border-radius: 5px;
    font-size: 1rem;
    background: #fff;
    line-height: 1em;
    transition: all 200ms ease-out;
    font-family: "Lota Grotesque", Arial, Helvetica, sans-serif;

    svg {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &__value {
    position: absolute;
    display: inline-block;
    font-size: 1rem;
    line-height: 1.5rem;
    z-index: 1;
    top: 13px;
    left: 7px;
    padding: 0 5px;
    transition: all 200ms ease-out;
    cursor: text;
    pointer-events: none;
  }

  &__label {
    position: absolute;
    display: inline-block;
    font-size: 1rem;
    line-height: 1.5rem;
    z-index: 1;
    top: 13px;
    left: 7px;
    background: #fff;
    color: #939393;
    padding: 0 5px;
    transition: all 200ms ease-out;
    cursor: text;
    pointer-events: none;

    .v-select--filled & {
      font-size: 0.75rem;
      transform: translateY(-25px);
    }
  }

  &__select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: 0;
    opacity: 0;

    &:focus ~ .v-select__wrapper {
      border-color: #0084ff;
      box-shadow: 0 0 0 1px #0084ff;
    }

    .v-select--filled &:focus ~ .v-select__wrapper .v-select__label {
      color: #0084ff;
    }
  }
}
</style>
